<section class="tw-bg-[#F7F7F7] tw-py-10 tw-px-4 lg:tw-px-20">
    <div
        class="content tw-max-w-[1280px] tw-mx-auto tw-px-[15px] tw-items-center"
    >
        <h2
            class="tw-text-center !tw-text-[28px] md:!tw-text-[40px] tw-w-full tw-text-[#0F3172] !tw-mb-[25px] !tw-font-bold"
        >
            {{ "HOME.PRODUCT_AND_SERVICES" | translate }}
        </h2>

        <div
            class="tw-hidden sm:tw-flex- sm:tw-grid lg:tw-grid-cols-2 xl:tw-grid-cols-4 tw-flex-wrap tw-gap-[10px] tw-justify-center"
        >
            <div
                data-sal="slide-up"
                data-sal-delay="300"
                data-sal-duration="1000"
                class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-w-full tw-h-[289px]"
            >
                <img
                    src="assets/images/icons/Finance.png"
                    alt="Financing Options"
                    class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                />
                <p
                    class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[18px]"
                >
                    {{ "COMMON.BUSINESS_FINANCING_TITLE" | translate }}
                </p>
                <p class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[16px]">
                    <a
                        class="tw-underline"
                        href="/business-financing"
                        ga-event-id="find_text_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="Find Text Click"
                        ga-track="track"
                        >{{ "HOME.BUSINESS_FINANCING_DESC_1" | translate }}</a
                    >
                    {{ "HOME.BUSINESS_FINANCING_DESC_2" | translate }}
                </p>
            </div>

            <div
                data-sal="slide-up"
                data-sal-delay="500"
                data-sal-duration="1000"
                class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-w-full tw-h-[289px]"
            >
                <img
                    src="assets/images/icons/Process.png"
                    alt="Seamless Application"
                    class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                />
                <p
                    class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[18px]"
                >
                    {{ "DIGITAL_GUARANTEE" | translate }}
                </p>
                <p class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[16px]">
                    {{ "HOME.DIGITAL_GUARANTEE_DESC_1" | translate }}
                    <a
                        class="tw-underline"
                        href="/digital-guarantee"
                        ga-event-id="digital_guarantee_text_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="Digital Guarantee Text Click"
                        ga-track="track"
                        >{{ "HOME.DIGITAL_GUARANTEE_DESC_2" | translate }} </a
                    >{{ "HOME.DIGITAL_GUARANTEE_DESC_3" | translate }}
                </p>
            </div>

            <div
                data-sal="slide-up"
                data-sal-delay="700"
                data-sal-duration="1000"
                class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-w-full tw-h-[289px]"
            >
                <img
                    src="assets/images/icons/Wallet.png"
                    alt="Trusted Partners"
                    class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                />
                <p
                    class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[18px]"
                >
                    {{ "COMMON.BEYOND_FINANCING" | translate }}
                </p>
                <p class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[16px]">
                    {{ "HOME.BEYOND_FINANCING_DESC_1" | translate }}
                    <a
                        class="tw-underline"
                        href="/insurance"
                        ga-event-id="services_text_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="Services Text Click"
                        ga-track="track"
                        >{{ "HOME.BEYOND_FINANCING_DESC_2" | translate }}</a
                    >
                    {{ "HOME.BEYOND_FINANCING_DESC_3" | translate }}
                </p>
            </div>

            <div
                data-sal="slide-up"
                data-sal-delay="900"
                data-sal-duration="1000"
                class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-w-full tw-h-[289px]"
            >
                <img
                    src="assets/images/icons/Calculator.png"
                    alt="Smart Tools"
                    class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                />
                <p
                    class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[18px]"
                >
                    {{ "HOME.FINANCING_CALCULATOR" | translate }}
                </p>
                <p class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[16px]">
                    <a
                        class="tw-underline"
                        href="/financing-calculator"
                        ga-event-id="estimate_text_homepage_click"
                        ga-event-category="Homepage Button"
                        ga-event-label="Estimate Text Click"
                        ga-track="track"
                        >{{ "HOME.FINANCING_CALCULATOR_DESC_1" | translate }}</a
                    >
                    {{ "HOME.FINANCING_CALCULATOR_DESC_2" | translate }}
                </p>
            </div>
        </div>
        <div
            class="tw-block sm:tw-hidden"
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-duration="1000"
        >
            <ngx-slick-carousel class="carousel p-n-s" [config]="slideConfig">
                <div
                    ngxSlickItem
                    class="tw-bg-white tw-rounded-2xl tw-p-7 tw-text-center tw-w-full !tw-h-[289px] !tw-mr-[20px]"
                >
                    <img
                        src="assets/images/icons/Finance.png"
                        alt="Financing Options"
                        class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                    />
                    <p
                        class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[18px]"
                    >
                        {{ "COMMON.BUSINESS_FINANCING_TITLE" | translate }}
                    </p>
                    <p
                        class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[16px]"
                    >
                        <a
                            class="tw-underline"
                            href="/business-financing"
                            ga-event-id="find_text_homepage_click"
                            ga-event-category="Homepage Button"
                            ga-event-label="Find Text Click"
                            ga-track="track"
                            >{{
                                "HOME.BUSINESS_FINANCING_DESC_1" | translate
                            }}</a
                        >
                        {{ "HOME.BUSINESS_FINANCING_DESC_2" | translate }}
                    </p>
                </div>

                <div
                    ngxSlickItem
                    class="tw-bg-white tw-rounded-2xl tw-p-7 tw-text-center tw-w-full !tw-h-[289px] !tw-mr-[20px]"
                >
                    <img
                        src="assets/images/icons/Process.png"
                        alt="Seamless Application"
                        class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                    />
                    <p
                        class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[18px]"
                    >
                        {{ "DIGITAL_GUARANTEE" | translate }}
                    </p>
                    <p
                        class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[16px]"
                    >
                        {{ "HOME.DIGITAL_GUARANTEE_DESC_1" | translate }}
                        <a
                            class="tw-underline"
                            href="/digital-guarantee"
                            ga-event-id="digital_guarantee_text_homepage_click"
                            ga-event-category="Homepage Button"
                            ga-event-label="Digital Guarantee Text Click"
                            ga-track="track"
                            >{{
                                "HOME.DIGITAL_GUARANTEE_DESC_2" | translate
                            }} </a
                        >{{ "HOME.DIGITAL_GUARANTEE_DESC_3" | translate }}
                    </p>
                </div>

                <div
                    ngxSlickItem
                    class="tw-bg-white tw-rounded-2xl tw-p-7 tw-text-center tw-w-full !tw-h-[289px] !tw-mr-[20px]"
                >
                    <img
                        src="assets/images/icons/Wallet.png"
                        alt="Trusted Partners"
                        class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                    />
                    <p
                        class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[18px]"
                    >
                        {{ "COMMON.BEYOND_FINANCING" | translate }}
                    </p>
                    <p
                        class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[16px]"
                    >
                        {{ "HOME.BEYOND_FINANCING_DESC_1" | translate }}
                        <a
                            class="tw-underline"
                            href="/insurance"
                            ga-event-id="services_text_homepage_click"
                            ga-event-category="Homepage Button"
                            ga-event-label="Services Text Click"
                            ga-track="track"
                            >{{ "HOME.BEYOND_FINANCING_DESC_2" | translate }}</a
                        >
                        {{ "HOME.BEYOND_FINANCING_DESC_3" | translate }}
                    </p>
                </div>

                <div
                    ngxSlickItem
                    class="tw-bg-white tw-rounded-2xl tw-p-7 tw-text-center tw-w-full !tw-h-[289px] !tw-mx-[10px]"
                >
                    <img
                        src="assets/images/icons/Calculator.png"
                        alt="Smart Tools"
                        class="tw-mx-auto tw-mb-4 tw-h-[48px] tw-w-[48px] sm:tw-h-[84px] sm:tw-w-[84px]"
                    />
                    <p
                        class="tw-font-bold tw-text-lg tw-mb-2 !tw-text-[20px] sm:!tw-text-[18px]"
                    >
                        {{ "HOME.FINANCING_CALCULATOR" | translate }}
                    </p>
                    <p
                        class="tw-text-black-600 !tw-text-[14px] sm:!tw-text-[16px]"
                    >
                        <a
                            class="tw-underline"
                            href="/financing-calculator"
                            ga-event-id="estimate_text_homepage_click"
                            ga-event-category="Homepage Button"
                            ga-event-label="Estimate Text Click"
                            ga-track="track"
                            >{{
                                "HOME.FINANCING_CALCULATOR_DESC_1" | translate
                            }}</a
                        >
                        {{ "HOME.FINANCING_CALCULATOR_DESC_2" | translate }}
                    </p>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</section>
